/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import ResizeObserver from 'react-resize-observer';
import Shimmer from 'react-shimmer-effect';
import IcomoonReact from 'icomoon-react';
import { Formik, Form } from 'formik';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import useCalendar from './hooks/useCalendar';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import Spinner from '../../../../shared/components/Spinner/Spinner';
import Input from '../../../../shared/_TBComponents/Input/index';
import SelectBox from '../../../../shared/_TBComponents/SelectBox/index';
import CreateLiftInputs from './CreateLiftInputs';
import {
  createExercise,
  setNewPreSaveItemFromCreateExerciseForm,
  addPreSavedItemToCalendarItemsArray,
  addPreSavedItemToProgramItemsArray,
} from '../../ducks/calendarActions';
import CreateSAQCFormInputs from './CreateSAQCFormInputs';
import CreateCircuitsFormInputs from './CreateCircuitsFormInputs';
import CreateNotesFormInputs from './CreateNotesFormInputs';
import CreateWarmUpOrCooldownFormInputs from './CreateWarmpUpOrCooldownFormInputs';
import CreateQuestionnaireFormInputs from './CreateQuestionnaireFormInputs';
import generateUniqueId from '../../../../shared/utils/generateUniqueId';
import { EXERCISE_TYPE, calendarIcons } from '../../../../shared/constants';
import useCalendarAutoSaveCalendarItems from './hooks/useCalendarAutoSaveCalendarItems';
import { showErrorToast } from '../../../../shared/utils/toastManager';

const FormWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
`;

const SpinnerWrapper = styled('div')`
.spinner-container {
  min-height: 500px;
}
`;

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SaveButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  margin-top: 6px
;  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  background: ${(props) => props.backgroundColor};
  color: white;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  user-select: none;
  border: 1px solid ${(props) => props.backgroundColor};
  transition: ${TransitionGlobal};
  cursor: pointer;
  ${(props) => !props.disabled && 'cursor: pointer;'}
  ${(props) => !props.disabled && ':hover { opacity: 0.7; }'}
`;

const CancelButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  color: #444444;
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  user-select: none;
  border: 2px solid #444444;
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const NameAndTypeWrapper = styled('div')`
 display: flex;
 flex-wrap: wrap;
 gap: 16px;
`;

const ChangingInputsContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

const LoadingWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;
const LoadingShimmerTopRowWrapper = styled('div')`
  display: flex;
  width: 100%;
  gap: 16px;
  ${(props) => props.containerWidth < 528 && 'flex-wrap: wrap'};
`;

const TopInputLoadingShimmer = styled('div')`
  display: flex;
  height: 66px;
  width: 100%;
  border-radius: 4px;
`;

const DescriptionLoadingShimmer = styled('div')`
  display: flex;
  height: 290px;
  width: 100%;
  border-radius: 4px;
`;

const LoadingShimmerURLBox = styled('div')`
 display: flex;
 flex: 1;
 flex-direction: column;
 gap: 16px;
 border-radius: 4px;
 min-width: ${(props) => (props.containerWidth < 400
    ? '250px'
    : props.containerWidth >= 528 && props.containerWidth < 700
      ? '250px'
      : '350px')};
${(props) => (props.containerWidth >= 700 && 'max-width: 350px')};
`;

const LoadingShimmerBottomRow = styled('div')`
  display: flex;
  height: 100px;
  width: 100%;
  border-radius: 4px;
`;

const NoExerciseManagementOverlay = styled('div')`
display: flex;
align-items: center;
justify-content: center;
position: absolute;
height: 100%;
width: 100%;
z-index: 1000;
backdrop-filter: blur(1.5px);
`;

const ExerciseManagementWarning = styled('div')`
  display: flex;
  gap: 12px;
  background: #FFFBEB;
  border: 2px solid #FFCB47;
  border-radius: 8px;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 11px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  line-height: 1.4;
  color: #333333;
  p {
    font-size: 12pt;
  }
`;

const IconContainer = styled('div')`
  display: flex;
  min-width: 30px;
  jutify-content: center;
  align-items: center;
`;

const CreateNewExerciseForm = ({ closeModal, onSuccessOverride }) => {
  const dispatch = useDispatch();
  const {
    handleGetInitialValues,
    handleGetFormValidationSchema,
    handleGetUpdatedValuesToSubmit,
  } = useCalendar();
  const {
    handleAutoSaveCalendarItem,
  } = useCalendarAutoSaveCalendarItems();

  const typeSelectRef = useRef(null);
  const containerRef = useRef(null);
  const iframelyError = useSelector((state) => state.calendar.data.iframelyError);
  const isMediaLoading = useSelector((state) => state.calendar.ui.isMediaLoading);
  const isQuestionsForAccountLoading = useSelector((state) => state.calendar.ui.isQuestionsForAccountLoading);
  const modalData = useSelector((state) => state.calendar.data.modalData);
  const sideBarExerciseSearchTerm = useSelector((state) => state.calendar.data.sideBarExerciseSearchTerm);
  const exercisePickerSearchTerm = useSelector((state) => state.calendar.data.exercisePickerSearchTerm);
  const searchTermForInitialValue = modalData?.openedFromExercisePicker ? exercisePickerSearchTerm : sideBarExerciseSearchTerm;
  const [modalType, setModalType] = useState(modalData?.type || 'L');
  const [persistedName, setPersistedName] = useState(
    searchTermForInitialValue,
  );
  const [containerWidth, setContainerWidth] = useState(null);
  const [isTypeChangeLoading, setIsTypeChangeLoading] = useState(false);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const hasExerciseManagementAccess = currentUser?.userSettings?.exercises === 1;

  const accountCode = currentUser?.accountCode;
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const date = new Date(selectedDate);
  const endpointFormattedDate = moment(date).format('YYYY-MM-DD');
  const isFetchedExerciseLoading = useSelector((state) => state.calendar.ui.isFetchedExerciseLoading);
  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const weekViewHorizontallyExpandedDay = useSelector(
    (state) => state.calendar.data.weekViewExpandedDay,
  );
  const viewType = useSelector((state) => state.calendar.data.viewType);

  const handleMarkAllTouched = (formValues, setTouched) => {
    setTouched(
      Object.keys(formValues).reduce((acc, field) => {
        acc[field] = true;
        return acc;
      }, {}),
    );
  };

  const isSubmitDisabled = (errors, touched, isSubmitting) => {
    if (iframelyError || (Object.keys(errors).length > 0 && Object.keys(touched).length > 0) || Object.keys(touched).length === 0 || isMediaLoading || isSubmitting) {
      return true;
    }
    return false;
  };

  const validateNameAndSetFieldErrorOnChange = async (value, setFieldError, nameValidationSchema) => {
    try {
      // eslint-disable-next-line no-unused-vars
      const validatedValue = await nameValidationSchema.validate(value);
    } catch (err) {
      setFieldError('name', err.message);
    }
  };

  const getTypeOptions = (currentTypeValue) => [
    {
      name: 'Lift',
      id: 'L',
      icon: 'lift',
      color: '#6C7A89',
      squareContainer: true,
      backgroundColor: 'rgba(108, 122, 137, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'L',
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'SAQ+C',
      id: 'R',
      icon: 'cardio',
      color: '#59ABE3',
      squareContainer: true,
      backgroundColor: 'rgba(89, 171, 227, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'R',
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Circuit',
      id: 'C',
      icon: 'circuit',
      color: '#F89406',
      squareContainer: true,
      backgroundColor: 'rgba(248, 148, 6, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'C',
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Questionnaire',
      id: 'S',
      icon: 'science',
      color: '#9B59B6',
      squareContainer: true,
      backgroundColor: 'rgba(155, 89, 182, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'S',
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Notes',
      id: 'N',
      icon: 'note',
      color: '#F9BF3B',
      squareContainer: true,
      backgroundColor: 'rgba(249, 191, 59, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'N',
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Warm-Up',
      id: 'W',
      icon: 'warmup',
      color: '#E74C3C',
      squareContainer: true,
      backgroundColor: 'rgba(231, 76, 60, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'W',
      checkmarkColor: '#BDBDBD',
    },
    {
      name: 'Cooldown',
      id: 'CD',
      icon: 'cooldown',
      color: '#1787FB',
      squareContainer: true,
      backgroundColor: 'rgba(23, 135, 251, 0.2)',
      includeIconContainer: true,
      includeCheckmark: currentTypeValue === 'CD',
      checkmarkColor: '#BDBDBD',
    },
  ];

  const customSelectStylesType = {
    control: (provided, state) => ({
      ...provided,
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 400,
      borderColor: state.isFocused ? 'lightgray' : 'lightgray',
      boxShadow: state.isFocused ? 'none' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? 'lightgray' : 'lightgray',
      },
    }),
    option: (provided, state) => ({
      ...provided,
      padding: '4px',
      borderRadius: '4px',
      backgroundColor: 'white',
      color: state.isSelected ? '#BDBDBD' : '#444444',
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      marginBottom: '8px',
      fontWeight: 400,
      '&:hover': {
        backgroundColor: '#FCFCFC',
      },
    }),
    menu: (provided) => ({
      ...provided,
      border: '0px',
      minWidth: '200px',
      padding: '16px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '100%',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9E9E9E',
    }),
    noOptionsMessage: (provided) => ({
      ...provided,
      fontSize: '16px',
      fontFamily: 'nunito sans',
    }),
  };

  const initialValues = useMemo(() => (
    handleGetInitialValues(modalType, persistedName, modalData)
  ), [modalType, modalData]);

  return (
    <Formik
          key={`${modalType}`}
          enableReinitialize
          initialValues={initialValues}
          validationSchema={handleGetFormValidationSchema(modalType, modalData)}
          onSubmit={(values, { setSubmitting, errors }) => {
            /** returns an updated formatted values object based on type */
            const updatedValues = handleGetUpdatedValuesToSubmit(values);
            if (!errors) {
              setSubmitting(true);
            }

            /** create new exercise for account with error handling */
            dispatch(setNewPreSaveItemFromCreateExerciseForm(null));
            dispatch(createExercise(accountCode, updatedValues, {
              // The AI import path (onSuccessOverride set) shows its own
              // feedback in the wizard — suppress the calendar's "Exercise
              // created" success toast and createExercise's generic error toast
              // so they don't leak on top of the wizard UI.
              silent: !!onSuccessOverride,
              onSuccess: (response) => {
                // When the modal is opened from a host that just wants the
                // created exercise back (e.g. AI program import's swap flow),
                // skip all calendar-side effects (auto-save, pre-save items)
                // and hand the response straight to the host.
                if (onSuccessOverride) {
                  setSubmitting(false);
                  onSuccessOverride(response);
                  closeModal();
                  return;
                }
                /** if the type created is questionnaire, warm up, cooldown, health
                 notes or progression then we are going to save the
                 the calendar item directly and add it, if it is any other exercise type we
                 need to create a presave item instead
                 */
                if (response?.type === EXERCISE_TYPE.Questionnaire
                   || response?.type === EXERCISE_TYPE.WarmUp
                   || response?.type === EXERCISE_TYPE.Cooldown
                   || response?.type === EXERCISE_TYPE.Health
                   || response?.type === EXERCISE_TYPE.Note
                   || response?.type === EXERCISE_TYPE.Progression) {
                  handleAutoSaveCalendarItem(response, setSubmitting, closeModal);
                } else {
                  setSubmitting(false);
                  /** if add exercise is successful then add pre save item and close modal */
                  const newItem = {
                    ...response,
                    icon: calendarIcons[response.typeDescription].icon,
                    title: response.name,
                    exerciseId: parseInt(response.id, 10),
                    id: `${response.id}-${generateUniqueId()}`,
                    assignedId: `${response.id}-${generateUniqueId()}`,
                    preSave: true,
                  };
                  dispatch(setNewPreSaveItemFromCreateExerciseForm(newItem));
                  /** set redux call to add pre saved item to calendar items array or program items array in redux */
                  if (programType === 'free-form-program') {
                    dispatch(addPreSavedItemToProgramItemsArray(newItem, weekViewHorizontallyExpandedDay != null && viewType === 'weekView' ? weekViewHorizontallyExpandedDay : selectedProgramDayNumber));
                  } else {
                    dispatch(addPreSavedItemToCalendarItemsArray(
                      newItem,
                      modalData?.targetDate
                        || (weekViewHorizontallyExpandedDay != null && viewType === 'weekView'
                          ? moment(weekViewHorizontallyExpandedDay).format('YYYY-MM-DD')
                          : endpointFormattedDate),
                    ));
                  }
                  closeModal();
                }
              },
              onError: () => {
                setSubmitting(false);
                showErrorToast('Opps! Something went wrong. Unable to create new exercise.');
              },
            }));
          }}
          render={({
            errors,
            touched,
            handleSubmit,
            handleChange,
            values,
            setFieldValue,
            handleBlur,
            setFieldTouched,
            setFieldError,
            isSubmitting,
            validateForm,
            setTouched,
          }) => {
            const isReusableItem = modalData?.reusableItem === 1 || values.reusableItem === 1 || values.reusableItem === true || modalData?.reusableItem === true || values.type === 'L';
            /** if there is an initial value for name then marked that
             * field as touched and validate the value
             */
            if (values.name && !touched.name) {
              setTouched({ name: true });
              validateNameAndSetFieldErrorOnChange(values.name, setFieldError, handleGetFormValidationSchema(modalType)?.name, modalData);
            }
            /** if the type is note, cooldown or warm up and it's not a reusable item we
             * don't need to validate name so we are going to mark the field as touhced so that
             * we don't disalbed the save button in this case
             */
            if ((values?.reusableItem === false || values?.reusableItem === 0) && (values?.type === 'N' || values?.type === 'CD' || values?.type === 'W') && !touched.name) {
              setTouched({ name: true });
            }
            return (
              <Form>
                <FormWrapper>
                  {!modalData?.disabledEditModal && !hasExerciseManagementAccess && modalType === EXERCISE_TYPE.Lift && (
                  <NoExerciseManagementOverlay>
                    <ExerciseManagementWarning>
                      <IconContainer>
                        <IcomoonReact
                        iconSet={iconSet}
                        size={24}
                        icon='warning'
                        color='#F59E0B'
                        />
                      </IconContainer>
                      <Text>You do not have the user permissions required to save to the exercise database. Please Contact your administrator for more details.</Text>
                    </ExerciseManagementWarning>
                  </NoExerciseManagementOverlay>
                  )}
                  {isSubmitting || (values.type === 'S' && isFetchedExerciseLoading) ? (
                    <SpinnerWrapper>
                      <Spinner />
                    </SpinnerWrapper>
                  ) : (
                    <>
                      <ResizeObserver
                        onResize={(rect) => {
                          setContainerWidth(rect?.width);
                        }}
                      />
                      <NameAndTypeWrapper>
                        <Input
                          disabled={modalData?.disabledEditModal}
                          error={!!touched.name && !!errors.name}
                          errorMsg={errors.name}
                          fontSize='16px'
                          fontWeight={400}
                          textColor='#444444'
                          height='38px'
                          label='Name'
                          name='name'
                          onChange={(value) => {
                            setPersistedName(value.target.value);
                            handleChange(value);
                            setTouched({ name: true });
                            validateNameAndSetFieldErrorOnChange(value, setFieldError, handleGetFormValidationSchema(modalType, modalData)?.name);
                          }}
                          onBlur={handleBlur}
                          right='5px'
                          styledPropsLabel={{
                            fontSize: '16px',
                            fontWeight: 700,
                          }}
                          styledPropsWrapper={{
                            flex: 1,
                          }}
                          top='38px'
                          value={values.name}
                          width='100%'
                        />
                        <div style={{ zIndex: !hasExerciseManagementAccess && 1001, display: 'flex', minWidth: containerWidth < 527 ? '100%' : '200px' }} ref={typeSelectRef}>
                          <SelectBox
                            isDisabled={modalData?.disabledEditModal}
                            width='200px'
                            options={getTypeOptions(values.type)}
                            defaultValue={getTypeOptions(values.type)?.find((option) => option.id === values.type)}
                            onChangeFunction={(option) => {
                              setFieldValue('type', option.id);
                              setModalType(option.id);
                              if (option.id !== values.type) {
                                setIsTypeChangeLoading(true); /** Set loading to true immediately */

                                setTimeout(() => {
                                  setIsTypeChangeLoading(false); /** Change loading back to false after 800ms */
                                }, 800);
                              }
                            }}
                            onBlur={() => setFieldTouched('type', true)}
                            error={!!touched.type && !!errors.type}
                            errorMsg={errors.type}
                            title='Type'
                            titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                            customStyles={customSelectStylesType}
                            isClearable={false}
                          />
                        </div>
                      </NameAndTypeWrapper>
                      {isTypeChangeLoading || isQuestionsForAccountLoading ? (
                        <LoadingWrapper>
                          <LoadingShimmerTopRowWrapper containerWidth={containerWidth}>
                            <Shimmer>
                              <LoadingShimmerURLBox containerWidth={containerWidth} />
                            </Shimmer>
                            <div style={{
                              display: 'flex', flexDirection: 'column', width: '100%', gap: '16px',
                            }}
                            >
                              <Shimmer>
                                <TopInputLoadingShimmer />
                              </Shimmer>
                              <Shimmer>
                                <DescriptionLoadingShimmer />
                              </Shimmer>
                            </div>
                          </LoadingShimmerTopRowWrapper>
                          <Shimmer>
                            <LoadingShimmerBottomRow />
                          </Shimmer>
                        </LoadingWrapper>
                      ) : (
                        <ChangingInputsContainer>
                          {modalType === EXERCISE_TYPE.Lift && (
                          <CreateLiftInputs
                            errors={errors}
                            touched={touched}
                            handleChange={handleChange}
                            mediaType={values.mediaType}
                            videoUrlValue={values.videoUrl}
                            mediaUrlValue={values.mediaUrl}
                            trackingValue={values.tracking}
                            linkToValue={values.linkTo}
                            linkPercentageValue={values.linkPercentage}
                            setFieldValue={setFieldValue}
                            handleBlur={handleBlur}
                            setFieldTouched={setFieldTouched}
                            setTouched={setTouched}
                            setFieldError={setFieldError}
                            urlButtonValue={values.uploadOrUrl}
                            containerWidth={containerWidth}
                            completionOnlyValue={values.completionOnly}
                            coachCompletionValue={values.coachCompletion}
                            linkPercentageValidationSchema={handleGetFormValidationSchema(modalType, modalData)?.linkPercentage}
                            updateLinkedExerciseMaxValue={values.updateLinkedExerciseMax}
                            boadyWeightLiftValue={values.bodyweightLift}
                            trackVolumeLoadValue={values.trackVolumeLoad}
                            trackRepCountValue={values.trackRepCount}
                            barSpeedValue={values.barSpeed}
                            eachSideValue={values.eachSide}
                            peakPowerValue={values.peakPower}
                            tagsValue={values.tags}
                            hasExerciseManagementAccess={hasExerciseManagementAccess}
                          />
                          )}
                          {modalType === EXERCISE_TYPE.SAQC && (
                          <CreateSAQCFormInputs
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          mediaType={values.mediaType}
                          videoUrlValue={values.videoUrl}
                          mediaUrlValue={values.mediaUrl}
                          trackingValue={values.tracking}
                          linkToValue={values.linkTo}
                          linkPercentageValue={values.linkPercentage}
                          updateLinkedExerciseMaxValue={values.updateLinkedExerciseMax}
                          tagsValue={values.tags}
                          setFieldValue={setFieldValue}
                          handleBlur={handleBlur}
                          setFieldTouched={setFieldTouched}
                          setTouched={setTouched}
                          setFieldError={setFieldError}
                          urlButtonValue={values.uploadOrUrl}
                          containerWidth={containerWidth}
                          linkPercentageValidationSchema={handleGetFormValidationSchema(modalType, modalData)?.linkPercentage}
                          inputTypeValue={values.inputType}
                          unitValue={values.unit}
                          prSortOrderValue={values.prSortOrder}
                          reusableItemValue={values.reusableItem}
                          completionOnlyValue={values.cardioComp}
                          coachCompletionValue={values.cardioCoach}
                          hasExerciseManagementAccess={hasExerciseManagementAccess}
                          />
                          )}
                          {modalType === EXERCISE_TYPE.Circuit && (
                          <CreateCircuitsFormInputs
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          mediaType={values.mediaType}
                          videoUrlValue={values.videoUrl}
                          mediaUrlValue={values.mediaUrl}
                          trackingValue={values.tracking}
                          linkToValue={values.linkTo}
                          setFieldValue={setFieldValue}
                          handleBlur={handleBlur}
                          setFieldTouched={setFieldTouched}
                          setTouched={setTouched}
                          setFieldError={setFieldError}
                          urlButtonValue={values.uploadOrUrl}
                          containerWidth={containerWidth}
                          inputTypeValue={values.inputType}
                          prSortOrderValue={values.prSortOrder}
                          coachCompletionValue={values.coachCompletion}
                          documentId={values.documentId}
                          documentUrl={values.documentUrl}
                          reusableItemValue={values.reusableItem}
                          detailValue={values.detail}
                          detailTypeValue={values.detailType}
                          hasExerciseManagementAccess={hasExerciseManagementAccess}
                          />
                          )}

                          {modalType === EXERCISE_TYPE.Questionnaire && (
                          <CreateQuestionnaireFormInputs
                          errors={errors}
                          touched={touched}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          reusableItemValue={values.reusableItem}
                          trackingValue={values.track}
                          questionIdValues={values.questionIds}
                          questions={values.questions}
                          setTouched={setTouched}
                          hasExerciseManagementAccess={hasExerciseManagementAccess}
                          />
                          )}
                          {modalType === EXERCISE_TYPE.Note && (
                          <CreateNotesFormInputs
                          errors={errors}
                          touched={touched}
                          mediaType={values.mediaType}
                          videoUrlValue={values.videoUrl}
                          mediaUrlValue={values.mediaUrl}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          urlButtonValue={values.uploadOrUrl}
                          containerWidth={containerWidth}
                          reusableItemValue={values.reusableItem}
                          hasExerciseManagementAccess={hasExerciseManagementAccess}
                          />
                          )}
                          {(modalType === EXERCISE_TYPE.WarmUp || modalType === EXERCISE_TYPE.Cooldown) && (
                          <CreateWarmUpOrCooldownFormInputs
                          errors={errors}
                          touched={touched}
                          mediaType={values.mediaType}
                          videoUrlValue={values.videoUrl}
                          mediaUrlValue={values.mediaUrl}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          urlButtonValue={values.uploadOrUrl}
                          containerWidth={containerWidth}
                          reusableItemValue={values.reusableItem}
                          hasExerciseManagementAccess={hasExerciseManagementAccess}
                          />
                          )}
                        </ChangingInputsContainer>
                      )}
                    </>
                  )}
                  {(!modalData?.disabledEditModal && !hasExerciseManagementAccess && modalType === EXERCISE_TYPE.Lift) ? (null) : (
                    <ButtonsContainer ref={containerRef}>
                      {modalData?.disabledEditModal ? (
                        null
                      ) : (
                        <SaveButton
                      onClick={() => {
                        if (isSubmitDisabled(errors, touched, isSubmitting)) {
                          handleMarkAllTouched(values, setTouched);
                          validateForm();
                        } else {
                          handleSubmit();
                        }
                      }}
                      backgroundColor={isSubmitDisabled(errors, touched, isSubmitting) ? '#BDBDBD' : '#444444'}
                      disabled={isSubmitDisabled(errors, touched, isSubmitting)}
                        >
                          <Text color='white' fontSize='16px' fontWeight={700}>{isReusableItem ? 'SAVE AND ADD' : 'ADD EXERCISE'}</Text>
                        </SaveButton>
                      )}
                      {modalData?.disabledEditModal && !modalData?.isPreviewOnly && (
                      <SaveButton
                      backgroundColor='#444444'
                       onClick={() => {
                         const itemInfo = modalData?.itemInfoForEditModal;
                         const newItem = {
                           ...itemInfo,
                           icon: calendarIcons[itemInfo.typeDescription].icon,
                           title: itemInfo.name,
                           exerciseId: parseInt(itemInfo.id, 10),
                           id: `${itemInfo.id}-${generateUniqueId()}`,
                           assignedId: `${itemInfo.id}-${generateUniqueId()}`,
                           preSave: true,
                         };
                         /** set redux call to add pre saved item to calendar items array or program items array in redux */
                         if (programType === 'free-form-program') {
                           dispatch(addPreSavedItemToProgramItemsArray(newItem, weekViewHorizontallyExpandedDay != null && viewType === 'weekView' ? weekViewHorizontallyExpandedDay : selectedProgramDayNumber));
                         } else {
                           dispatch(addPreSavedItemToCalendarItemsArray(
                             newItem,
                             modalData?.targetDate
                               || (weekViewHorizontallyExpandedDay != null && viewType === 'weekView'
                                 ? moment(weekViewHorizontallyExpandedDay).format('YYYY-MM-DD')
                                 : endpointFormattedDate),
                           ));
                         }
                         closeModal();
                       }}
                      >
                        <Text color='white' fontSize='16px' fontWeight={700}>ADD EXERCISE</Text>
                      </SaveButton>
                      )}
                      <CancelButton onClick={() => {
                        closeModal();
                      }}
                      >
                        {modalData?.disabledEditModal ? (
                          <Text fontSize='16px' fontWeight={700}>CLOSE</Text>
                        ) : (
                          <Text fontSize='16px' fontWeight={700}>CANCEL</Text>
                        )}
                      </CancelButton>
                    </ButtonsContainer>
                  )}
                </FormWrapper>
              </Form>
            );
          }}
    />
  );
};

CreateNewExerciseForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  // Optional override invoked with the created exercise instead of the
  // form's default success path. Used by the AI import wizard to plug a
  // newly-created exercise into its row mapping.
  onSuccessOverride: PropTypes.func,
};

CreateNewExerciseForm.defaultProps = {
  onSuccessOverride: null,
};

export default CreateNewExerciseForm;
